import BillsCard from "~/components/Metrics/BillsCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const Bills = ({ siteId }: { siteId: string }) => {
  const { t } = useTranslation();
  const getBillsMetrics = async (query: MetricsAPI.GetMetricQuery) => {
    try {
      const { data } = await api.metrics.getBillsBySite({
        siteId,
        ...query,
      });
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <BillsCard
      title={`${t("title.averageBillBy")} ${t("text.site")}: ${siteId}`}
      onUpdate={getBillsMetrics}
    />
  );
};

export default Bills;
